import { Injectable } from '@angular/core';
import { HttpClient,HttpErrorResponse } from '@angular/common/http';
import { User } from '../_models';
import { HttpHeaders } from '@angular/common/http';
import { ListTest } from '../interface/testinterface'
import { Observable, AnonymousSubject } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { commonInterceptor } from 'app/interceptors/common-interceptors';


@Injectable()
export class OrganisationsService {
    constructor(private http: HttpClient) { }
    getOrganisationslist(page: number, pageSize: number,organisationfilter) {
        const formData = new FormData();
        formData.append('page',page.toString());   
        const httpOptions = {
            headers: new HttpHeaders({
            'orgtype':organisationfilter.organisationtype,
            'orgname':organisationfilter.orgname,
            'status':organisationfilter.orgstatus,
            'orgcity':organisationfilter.orgcity,
            })
        }
        return this.http.post<any>(environment.url+`listOrganisations`,formData,httpOptions)
    }
    createtest(test){
        let currentUser = JSON.parse(localStorage.getItem('currentUser'));
        let usermasterid=currentUser.user_master_id;
        let utoken=currentUser.utoken; 
        const httpOptions = {
            headers: new HttpHeaders({
                'utoken':  atob(utoken),
                'usermasterid': atob(usermasterid),
                'testname': test.testname,
                'status': test.status,
                'testmasterid':test.testid
            })
        };
        return this.http.post<any>(environment.url+`addEditTest`,'',httpOptions)
    }

    getedittestdata(testid){
        let currentUser = JSON.parse(localStorage.getItem('currentUser'));
        let usermasterid=currentUser.user_master_id;
        let utoken=currentUser.utoken; 
        const httpOptions = {
            headers: new HttpHeaders({
            'utoken':  atob(utoken),
            'usermasterid':atob(usermasterid),
            'tblname':'tbl_test_types_master',
            'comparecolumnname':'test_master_id',
            'comparecolumndata':testid
            })
        }
        return this.http.post<any>(environment.url+`getMasterDetails`,'',httpOptions).pipe(catchError(this.handleError));
    }

    updatestatus(orgid:string,status){
        let currentUser = JSON.parse(localStorage.getItem('currentUser'));
        let usermasterid=currentUser.user_master_id;
        let utoken=currentUser.utoken; 
        const httpOptions = {
            headers: new HttpHeaders({
                'tblname':'tbl_organisation_master',
                'comparecolumnname':'org_id',
                'comparecolumndata':orgid,
                'statuscolumnname':'status',
                'statusdata':status,
            })
        }
        return this.http.post<any>(environment.url+`changeStatus`,'',httpOptions).pipe(catchError(this.handleError));
    }



updateimagestatus(orgid:string,status)
{

const httpOptions = {
headers: new HttpHeaders({
'tblname':'tbl_organisation_images',
'comparecolumnname':'org_image_id',
'comparecolumndata':orgid,
'statuscolumnname':'status',
'statusdata':status,
 })
 }
return this.http.post<any>(environment.url+`changeStatus`
,'',httpOptions).pipe(catchError(this.handleError));
}



updatedatetimestatus(orgid:string,status)
{
let currentUser = JSON.parse(localStorage.getItem('currentUser'));
let usermasterid=currentUser.user_master_id;
let utoken=currentUser.utoken; 
const httpOptions = {
headers: new HttpHeaders({
'utoken':  atob(utoken),
'usermasterid':  atob(usermasterid),
'tblname':'tbl_org_working_hours',
'comparecolumnname':'org_working_hour_id',
'comparecolumndata':orgid,
'statuscolumnname':'status',
'statusdata':status,
 })
 }
return this.http.post<any>(environment.url+`changeStatus`
,'',httpOptions).pipe(catchError(this.handleError));
}









//new code end 1-3-2019

getallorganisation()
{
return this.http.post<any>(environment.url+`getOrganisations`,'').pipe(catchError(this.handleError));
}


//parent id

parentidorganisation(orgid)
{
let currentUser = JSON.parse(localStorage.getItem('currentUser'));
let usermasterid=currentUser.user_master_id;
let utoken=currentUser.utoken; 
const httpOptions = {
    headers: new HttpHeaders({
    'listtype':  "editorg",
    'orgid':""+orgid+""
    })
}
return this.http.post<any>(environment.url+`getOrganisations`,'',httpOptions).pipe(catchError(this.handleError));
}




    getSpecialities()
    {
        let currentUser = JSON.parse(localStorage.getItem('currentUser'));
        let usermasterid=currentUser.user_master_id;
        let utoken=currentUser.utoken; 
        const httpOptions = {
            headers: new HttpHeaders({
                'utoken':  atob(utoken),
                'usermasterid':  atob(usermasterid),
            })
        }
        return this.http.post<any>(environment.url+`getSpecialities`,'',httpOptions).pipe(catchError(this.handleError));
    }

    getSpecialitiesWithServiceType(serviceTypeId:any){
        let currentUser = JSON.parse(localStorage.getItem('currentUser'));
        let usermasterid=currentUser.user_master_id;
        let utoken=currentUser.utoken; 
        const httpOptions = {
            headers: new HttpHeaders({
                'utoken':  atob(utoken),
                'usermasterid':  atob(usermasterid),
                'servicetype':  serviceTypeId,
            })
        }
        return this.http.post<any>(environment.url+`getSpecialitiesWithServiceType`,'',httpOptions).pipe(catchError(this.handleError));
    }


organisation(orgid,formValues,formValue,custom)
{
    let currentUser = JSON.parse(localStorage.getItem('currentUser'));
    let usermasterid=currentUser.user_master_id;
    let utoken=currentUser.utoken; 


    if(orgid!=0)     
{





//console.log("formValue.ordanisationid",formValue.ordanisationid.length)

var parentid=""

if(formValue.ordanisationid!=undefined)
{
    if(formValue.ordanisationid.length !="0")
{
    parentid=formValue.ordanisationid[0].org_id

}

}


   // if(formValue.ordanisationid.length !="0")
//{




    const httpOptions = {
        headers: new HttpHeaders({
          'utoken':atob(utoken),
          'loginuserid':atob(usermasterid),
          'orgtype':formValue.orgtype,
          'orgid':""+orgid+"",
          'refralcode':formValue.refralcode,
           //'orgname':formValue.org_name,
           'parentid':parentid,
          'monworking':custom.mon,
          'orgstatus':formValue.orgstatus,
          'tueworking':custom.tue,
          'wedworking':custom.wen,
          'thuworking':custom.thu,
          'friworking':custom.fri,
          'satworking':custom.sat,
          'sunworking':custom.sun,
           })
          }

          //orgstatus

        return this.http.post<any>(environment.url+`editOrganisationProfile`
        ,formValues,httpOptions).pipe(catchError(this.handleError));
        
    
   // }
    /*
        else
        {
            const httpOptions = {
                headers: new HttpHeaders({
                  'utoken':atob(utoken),
                  'loginuserid':atob(usermasterid),
                  'orgtype':formValue.orgtype,
                  'orgid':""+orgid+"",
                  'orgstatus':formValue.orgstatus,
                   'orgname':formValue.org_name,
                  'monworking':custom.mon,
                  'tueworking':custom.tue,
                  'wedworking':custom.wen,
                  'thuworking':custom.thu,
                  'friworking':custom.fri,
                  'satworking':custom.sat,
                  'sunworking':custom.sun,
                   })
                  }
        
        
                return this.http.post<any>(environment.url+`editOrganisationProfile`
                ,formValues,httpOptions).pipe(catchError(this.handleError));


        }
*/


}   
     else
     {  



console.log("orgid edit",orgid)


if(formValue.ordanisationid!=undefined)
{

        const httpOptions = {
            headers: new HttpHeaders({
              'utoken':atob(utoken),
              'usermasterid':atob(usermasterid),
              'orgtype':formValue.orgtype,
              'orgname':formValue.org_name,
              'refralcode':formValue.refralcode,
              'parentid':formValue.ordanisationid[0].org_id,
              'monworking':custom.mon,
              'orgstatus':formValue.orgstatus,
              'tueworking':custom.tue,
              'wedworking':custom.wen,
              'thuworking':custom.thu,
              'friworking':custom.fri,
              'satworking':custom.sat,
              'sunworking':custom.sun,
               })
              }
    


return this.http.post<any>(environment.url+`addOrganisationProfile`
,formValues,httpOptions).pipe(catchError(this.handleError));
            }
            else
            {

                const httpOptions = {
                    headers: new HttpHeaders({
                      'utoken':atob(utoken),
                      'usermasterid':atob(usermasterid),
                      'orgtype':formValue.orgtype,
                      'refralcode':formValue.refralcode,
                       'orgname':formValue.org_name,
                        'monworking':custom.mon,
                        'orgstatus':formValue.orgstatus,
                      'tueworking':custom.tue,
                      'wedworking':custom.wen,
                      'thuworking':custom.thu,
                      'friworking':custom.fri,
                      'satworking':custom.sat,
                      'sunworking':custom.sun,
                       })
                      }
            
        
        
        return this.http.post<any>(environment.url+`addOrganisationProfile`
        ,formValues,httpOptions).pipe(catchError(this.handleError));


            }     


}
}


editorganisationlocation(organisationid,formValue)
{

console.log("formValue.gpscords",formValue.gpscords)


console.log("server",organisationid)

    let currentUser = JSON.parse(localStorage.getItem('currentUser'));
    let usermasterid=currentUser.user_master_id;
    let utoken=currentUser.utoken; 
    const httpOptions = {
        headers: new HttpHeaders({
'utoken':atob(utoken),
'loginuserid':atob(usermasterid),
'orgid':""+organisationid+"",
//'address1':formValue.address1,
//'address2':formValue.address2,
//'street':formValue.street,
//'area':formValue.area,
//'landmark':formValue.landmark,
//'countryid':formValue.countryid,
//'stateid':formValue.state_id,
//'gpscords':formValue.gpscords,
//'stateid':formValue.stateid,
//'cityid':formValue.city_id,
//'pincode':formValue.pincode
 
})
}





const formData = new FormData();
formData.append('address1',formValue.address1);  
formData.append('address2',formValue.address2);  
formData.append('street',formValue.street);  
formData.append('area',formValue.area);  
formData.append('landmark',formValue.landmark);  
formData.append('countryid',formValue.countryid);  
formData.append('stateid',formValue.state_id);  
//formData.append('stateid',formValue.stateid); 
formData.append('cityid',formValue.city_id);  
formData.append('pincode',formValue.pincode);  
formData.append('gpscords',formValue.gpscords);  









return this.http.post<any>(environment.url+`editOrgLocationDetails`
,formData,httpOptions).pipe(catchError(this.handleError));
}


//organisation location

editorganisationcontact(organisationid:any,formValue:any,editorganisationcontact:any){
    let currentUser = JSON.parse(localStorage.getItem('currentUser'));
    let usermasterid=currentUser.user_master_id;
    let utoken=currentUser.utoken; 



//console.log("formValue.website",formValue.website)
//console.log("editorganisationcontact",editorganisationcontact)


    const httpOptions = {
        headers: new HttpHeaders({
            'utoken':atob(utoken),
            'loginuserid':atob(usermasterid),
            'orgid':""+organisationid+"",
           // 'mobile1':formValue.mobile1,
         //   'mobile1public':editorganisationcontact.mobile1public,
          //  'mobile2':formValue.mobile2,
          //  'mobile2public':editorganisationcontact.mobile2public,
          //    'phone1':""+formValue.phone1+"",
         //   'phone1public':editorganisationcontact.phone1public,
           // 'phone2':formValue.phone2,
          //  'phone2public':editorganisationcontact.phone2public,
        //    'emailid1':formValue.emailid1,
         //   'emailid1public':editorganisationcontact.emailid1public,
         //   'emailid2':formValue.emailid2,
         //   'emailid2public':editorganisationcontact.emailid2public,
         //   'website':""+formValue.website+"",
        })
    }


    const formData = new FormData();
    formData.append('mobile1',formValue.mobile1);  
    formData.append('mobile1public',editorganisationcontact.mobile1public);  
    formData.append('mobile2',formValue.mobile2);  
    formData.append('mobile2public',editorganisationcontact.mobile2public);  
    formData.append('phone1',formValue.phone1);  
    formData.append('phone1public',editorganisationcontact.phone1public);  
    formData.append('phone2',formValue.phone2);  
    formData.append('phone2public',editorganisationcontact.phone2public);  
    formData.append('emailid1',formValue.emailid1);  
    formData.append('emailid1public',editorganisationcontact.emailid1public);  
    formData.append('emailid2',formValue.emailid2);  
    formData.append('emailid2public',editorganisationcontact.emailid2public);  
    formData.append('website',formValue.website);  





    return this.http.post<any>(environment.url+`editOrgContactDetails`,formData,httpOptions).pipe(catchError(this.handleError));
}




//organisation end


//location service start

getCountries(){
    let currentUser = JSON.parse(localStorage.getItem('currentUser'));
    let usermasterid=currentUser.user_master_id;
    let utoken=currentUser.utoken; 
    const httpOptions = {
        headers: new HttpHeaders({
            'utoken':  atob(utoken),
        })
    }
    return this.http.post<any>(environment.url+`getLiveCountries`,'',httpOptions).pipe(catchError(this.handleError));
}


getcity(val){
    const httpOptions = {
        headers: new HttpHeaders({
            'stateid':  val,
        })
    }
    return this.http.post<any>(environment.url+`getLiveCities`,'',httpOptions).pipe(catchError(this.handleError));
}





getCountriesorg(){
    let currentUser = JSON.parse(localStorage.getItem('currentUser'));
    let usermasterid=currentUser.user_master_id;
    let utoken=currentUser.utoken; 
    const httpOptions = {
        headers: new HttpHeaders({
            'utoken':  atob(utoken),
        })
    }
    return this.http.post<any>(environment.url+`getLiveCountries`,'',httpOptions).pipe(catchError(this.handleError));
}


getcityorg(val){
    const httpOptions = {
        headers: new HttpHeaders({
            'stateid':  val,
        })
    }
    return this.http.post<any>(environment.url+`getCities`,'',httpOptions).pipe(catchError(this.handleError));
}





getStateorg(val)
{

const httpOptions = {
headers: new HttpHeaders({
'countryid':  val,
})
}
return this.http.post<any>(environment.url+`getState`
,'',httpOptions).pipe(catchError(this.handleError));

}





getState(val)
{

const httpOptions = {
headers: new HttpHeaders({
'countryid':  val,
})
}
return this.http.post<any>(environment.url+`getLiveState`
,'',httpOptions).pipe(catchError(this.handleError));

}



//location service end





private handleError(error: HttpErrorResponse) 
{
// console.error('server error:', error);
if (error.error instanceof Error) {
const errMessage = error.error.message;
return Observable.throw(errMessage);
}
    return Observable.throw(error || 'Node.js server error');
}









geteditorganisation(orgid):Observable<any> 
{
let currentUser = JSON.parse(localStorage.getItem('currentUser'));
let usermasterid=currentUser.user_master_id;
let utoken=currentUser.utoken; 
const httpOptions = {

headers: new HttpHeaders({
'utoken':atob(utoken),
'loginuserid':atob(usermasterid),
'orgid':orgid
})
}
return this.http.post<any>(environment.url+`getOrganisationProfile`
,'',httpOptions)
}




getOrganisationLocContactDetails(orgid):Observable<any> 
{
let currentUser = JSON.parse(localStorage.getItem('currentUser'));
let usermasterid=currentUser.user_master_id;
let utoken=currentUser.utoken; 
const httpOptions = {

headers: new HttpHeaders({
'utoken':atob(utoken),
'loginuserid':atob(usermasterid),
'orgid':orgid
})
}
return this.http.post<any>(environment.url+`getOrganisationLocContactDetails`
,'',httpOptions)
}





getplandescription(orgid):Observable<any> 
{
let currentUser = JSON.parse(localStorage.getItem('currentUser'));
let usermasterid=currentUser.user_master_id;
let utoken=currentUser.utoken; 
const httpOptions = {

headers: new HttpHeaders({
'utoken':atob(utoken),
'loginuserid':atob(usermasterid),
'orgid':orgid
})
}
return this.http.post<any>(environment.url+`getPlans`
,'',httpOptions)
}


//ravi new code 2-26-2019

deleteimage(org_id,org_image_id,imagename)
{


    let currentUser = JSON.parse(localStorage.getItem('currentUser'));
    let usermasterid=currentUser.user_master_id;
    let utoken=currentUser.utoken; 


    const httpOptions = {
        headers: new HttpHeaders({
        'utoken':atob(utoken),
        'loginuserid':atob(usermasterid),
        'orgid':org_id,
         'imageid':org_image_id,
        'imagename':imagename
        })
        }
        return this.http.post<any>(environment.url+`deleteOrgImage`
        ,'',httpOptions)

}



saveworkinghoures(org_id,formdata)
{
    let currentUser = JSON.parse(localStorage.getItem('currentUser'));
    let usermasterid=currentUser.user_master_id;
    let utoken=currentUser.utoken; 


    const httpOptions = {
        headers: new HttpHeaders({
        'utoken':atob(utoken),
        'loginuserid':atob(usermasterid),
        'orgid':""+org_id+"",
        })
        }
        return this.http.post<any>(environment.url+`addEditOrganisationWorkingHrs`
        ,formdata,httpOptions)
}








    //ravi new code end 2-26-2019
    SubscribedPlans(orgid,planid,startdate,enddate):Observable<any>{
        let currentUser  = JSON.parse(localStorage.getItem('currentUser'));
        let usermasterid =currentUser.user_master_id;
        let utoken = currentUser.utoken; 
        const formData = new FormData();
        formData.append('utoken',atob(utoken));  
        formData.append('loginuserid',atob(usermasterid));  
        formData.append('orgid',orgid);  
        formData.append('planid',planid); 
        formData.append('paymentmode',"cheque");  
        formData.append('bankname',"HDFC");  
        formData.append('branchname',"HDFC Kalyan");  
        formData.append('chequeno',"chequeno");  
        formData.append('transactionid',"123456789");  
        return this.http.post<any>(environment.url+`addEditPlanSubscription`,formData)
    }

    listSubscribedPlans(orgId:any):Observable<any> {
        let currentUser = JSON.parse(localStorage.getItem('currentUser'));
        let usermasterid=currentUser.user_master_id;
        let utoken=currentUser.utoken; 
        const httpOptions = {
            headers: new HttpHeaders({
                'utoken':atob(utoken),
                'loginuserid':atob(usermasterid),
                'orgid':""+orgId+"",
            })
        }
        return this.http.post<any>(environment.url+`listSubscribedPlans`,'',httpOptions)
    }

    getQTRAQUserDetails(mobilenumber,orgid){
        let currentUser = JSON.parse(localStorage.getItem('currentUser'));
        let usermasterid=currentUser.user_master_id;
        let utoken=currentUser.utoken; 
        const httpOptions = {
        
        headers: new HttpHeaders({
        'utoken':atob(utoken),
        'loginuserid':atob(usermasterid),
        'mobileno':mobilenumber,
        'orgid':""+orgid+"",
        })
        }
        return this.http.post<any>(environment.url+`getQTRAQUserDetails`
        ,'',httpOptions)
    }

    addQTRAQUserDetails(formValue:any,dob_date:any,org_id:any){
        console.log("form Data",formValue);
        let currentUser = JSON.parse(localStorage.getItem('currentUser'));
        let usermasterid=currentUser.user_master_id;
        let utoken=currentUser.utoken; 
        console.log("org_id",org_id)
        console.log("mobileno",formValue.mobilenumber)
        console.log("firstname",formValue.firstname)
        console.log("middlename",formValue.middlename)
        console.log("formValue.lastname",formValue.lastname)
        console.log("dob",dob_date)
        console.log("gender",formValue.gender)
        console.log("countryid",formValue.countryid)
        console.log("stateid",formValue.stateid)
        console.log("cityid",formValue.cityid)
        console.log("pincode",formValue.pincode)
        console.log("emailid-----",formValue.emailid)
        console.log("isorgdefault",formValue.isorgdefault)
        console.log("formValue.qtraquserid",formValue.qtraquserid)
        console.log("otp",formValue.otp)

        var queueid = ""


       if(formValue.qtraquserid!=null){
        queueid = formValue.qtraquserid
       }else{
        queueid = ""
            
       }



        const httpOptions = { 
            headers: new HttpHeaders({
                /*
                'utoken':atob(utoken),
                'usermasterid':atob(usermasterid),
                "orgid":"1",
                "mobileno":formValue.mobileno,
                "firstname":formValue.firstname,
                "middlename":formValue.middlename, 
                "lastname":formValue.lastname,
                "dob":dob_date,
                "gender":formValue.gender,
                "countryid":formValue.countryid,
                "stateid":formValue.stateid,
                "cityid":formValue.cityid,
                "pincode":formValue.pincode,
                "emailid":formValue.emailid,
                "isorgdefault":formValue.isorgdefault,
                "otp":formValue.otp
                */    
                'utoken':atob(utoken),
                'otptype':'registration',
                'loginuserid':atob(usermasterid),
                "orgid":""+org_id+"",
                "mobileno":formValue.mobilenumber,
                "firstname":formValue.firstname,
                "middlename":formValue.middlename, 
                "lastname":formValue.lastname,
                "dob":dob_date,
                "gender":formValue.gender,
                "countryid":formValue.countryid,
                "stateid":formValue.stateid,
                "cityid":formValue.cityid,
                 "emailid":formValue.emailid,
                "isorgdefault":formValue.isorgdefault,
                "qtraquserid":queueid,
                "otp":""+formValue.otp+""
            })
        }
        return this.http.post<any>(environment.url+`addQTRAQUser`,'',httpOptions)
    }

    generateOtp(onconvalueget,submobile){
        let currentUser = JSON.parse(localStorage.getItem('currentUser'));
        let usermasterid=currentUser.user_master_id;
        let utoken=currentUser.utoken; 
        const httpOptions = {
            headers: new HttpHeaders({
                'utoken':atob(utoken),
                'usermasterid':atob(usermasterid),
                'mobileno':submobile,
                "countryid":onconvalueget,
                "otptype":'registration'
            })
        }
        return this.http.post<any>(environment.url+`generateOtp`,'',httpOptions)


    }


    makedefaultuser(user_master_id,org_id){
        let currentUser = JSON.parse(localStorage.getItem('currentUser'));
        let usermasterid=currentUser.user_master_id;
        let utoken=currentUser.utoken; 
        const httpOptions = {
            headers: new HttpHeaders({
                'utoken':atob(utoken),
                'usermasterid':atob(usermasterid),
                'qtraquserid':user_master_id,
            })
        }
        return this.http.post<any>(environment.url+`generateOtp`,'',httpOptions)
    }



    getOrganizationTypeActive(){
        let currentUser = JSON.parse(localStorage.getItem('currentUser'));
        let utoken=currentUser.utoken; 
        const httpOptions = {
            headers: new HttpHeaders({
                'utoken':atob(utoken),
                'alldata':'Yes'
            })
        }
        return this.http.post<any>(environment.url+`listActiveServiceType`,'',httpOptions)
    }



    getLiveCityforSearch(){
        let currentUser = JSON.parse(localStorage.getItem('currentUser'));
        let utoken=currentUser.utoken; 
        const httpOptions = {
            headers: new HttpHeaders({
                'utoken':atob(utoken),
            })
        }
        return this.http.post<any>(environment.url+`getLiveCitiesForSearch`,'',httpOptions)
    }




    getOrganizationType(){
        const httpOptions = {
            headers: new HttpHeaders({
                'alldata':'Yes'
            })
        }
        return this.http.post<any>(environment.url+`listServiceType`,'',httpOptions)
    }



    getOrganisationTypeList(page:any, pageSize: number,organisationTypeFilter){
        const formData   = new FormData();
        const httpOptions = {
            headers: new HttpHeaders({
                'page':page,
                'servicetype':organisationTypeFilter.orgtype,
                'status':organisationTypeFilter.orgtypestatus,
            })
        }
        return this.http.post<any>(environment.url+`listServiceType`,formData,httpOptions)
    }

    getOrganisationTypeDetails(serviceTypeId:any){
        const formData   = new FormData();
        let currentUser  = JSON.parse(localStorage.getItem('currentUser'));
        let utoken = currentUser.utoken; 
        const httpOptions = {
            headers: new HttpHeaders({
                'utoken':atob(utoken),
                'servicetypeid':serviceTypeId
            })
        }
        return this.http.post<any>(environment.url+`getServiceTypes`,formData,httpOptions)
    }

    addEditOrganisationType(formValue:any,orgTypeid:any = ""){
        let currentUser  = JSON.parse(localStorage.getItem('currentUser'));
        let usermasterid = currentUser.user_master_id;
        let utoken=currentUser.utoken; 
        const httpOptions = { 
            headers: new HttpHeaders({
                'utoken':atob(utoken),
                'loginuserid':atob(usermasterid),
                "servicetypeid":orgTypeid,
                "servicetype":formValue.value.orgType,
                "status":formValue.value.orgTypeStatus,
            })
        }
        return this.http.post<any>(environment.url+`addEditServiceType`,'',httpOptions)
    }

    getProviderList(orgId:any){
        let currentUser  = JSON.parse(localStorage.getItem('currentUser'));
        let usermasterid = currentUser.user_master_id;
        let utoken=currentUser.utoken; 
        const httpOptions = { 
            headers: new HttpHeaders({
                'utoken':atob(utoken),
                'loginuserid':atob(usermasterid),
                "orgid":""+orgId+"",
            })
        }
        return this.http.post<any>(environment.url+`getProvidersList`,'',httpOptions)
    }

//ravi code start 5-13-2019


checkadminuserexist(orgId:any){
    let currentUser  = JSON.parse(localStorage.getItem('currentUser'));
    let usermasterid = currentUser.user_master_id;
    let utoken=currentUser.utoken; 
    const httpOptions = { 
        headers: new HttpHeaders({
            'utoken':atob(utoken),
            'loginuserid':atob(usermasterid),
            "orgid":""+orgId+"",
        })
    }
    return this.http.post<any>(environment.url+`checkadminuserexist`,'',httpOptions)
}
//ravi code end 5-13-2019




//ravi new code  parent 5-15-2019 start


getparentgetallorganisation()
{
let currentUser = JSON.parse(localStorage.getItem('currentUser'));
let usermasterid=currentUser.user_master_id;
let utoken=currentUser.utoken; 
const httpOptions = {
headers: new HttpHeaders({
'utoken':  atob(utoken),
'usermasterid':  atob(usermasterid),
})
}
return this.http.post<any>(environment.url+`parentOrganisations`
,'',httpOptions).pipe(catchError(this.handleError));
}


//parent id

getparentidorganisation(orgid)
{
console.log("editorrrrrg")
console.log("orgid",orgid)
let currentUser = JSON.parse(localStorage.getItem('currentUser'));
let usermasterid=currentUser.user_master_id;
let utoken=currentUser.utoken; 
const httpOptions = {
headers: new HttpHeaders({
'utoken':  atob(utoken),
'usermasterid':  atob(usermasterid),
'listtype':  "editorg",
'orgid':""+orgid+""
})
}
return this.http.post<any>(environment.url+`parentOrganisations`
,'',httpOptions).pipe(catchError(this.handleError));
}



deleteorglogo(org_id)
{
    console.log("editorrrrrg")
    console.log("orgid",org_id)
    let currentUser = JSON.parse(localStorage.getItem('currentUser'));
    let usermasterid=currentUser.user_master_id;
    let utoken=currentUser.utoken; 
    const httpOptions = {
    headers: new HttpHeaders({
    'utoken':  atob(utoken),
    'loginuserid':  atob(usermasterid),
     'orgid':""+org_id+""
    })
    }
    return this.http.post<any>(environment.url+`deleteorglogo`
    ,'',httpOptions).pipe(catchError(this.handleError));


}




//ravi new code end parent 5-15-2019 end


}






// WEBPACK FOOTER //
// ./src/app/_services/organisations.service.ts